var core = module.exports = { version: '2.5.0' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



// WEBPACK FOOTER //
// ./~/core-js/modules/_core.js